<script lang="ts">
    import { getDBEntry } from "../../api"
    import { spaLink } from "../actions"
    import { navigationCache, location } from "../store"
    import CartButton from "./CartButton.svelte"

    let navigationEntry: NavigationEntry

    function elementsToCache(elements: NavigationElement[]) {
        elements.forEach((el) => {
            if (!el.external) {
                if (!$navigationCache[el.page]) {
                    // only first hit to cache
                    $navigationCache[el.page] = el
                }
                if (el.elements?.length > 0) {
                    elementsToCache(el.elements)
                }
            }
        })
    }

    getDBEntry("navigation", {
        tree: 0,
    }).then((nav) => {
        navigationEntry = nav
        elementsToCache(nav.elements)
    })

    let navOpen = false

    let subNavOpen: { [key: number]: boolean } = {}

    $: if (!navOpen) {
        // close all hidden subNavs
        subNavOpen = {}
    }

    let windowWidth: number

    $: isMobile = windowWidth < 1024

    // close on location change
    $: if ($location) {
        navOpen = false
    }

    let y = 0
    let lastY = 0

    function updateHeader(y: number) {
        const dy = lastY - y
        lastY = y
        if (Math.abs(dy) <= 0) {
            // no movement
            return ""
        } else if (y <= 0) {
            // top
            return ""
        } else if (dy < 0) {
            return "moveUp"
        } else {
            return ""
        }
    }

    $: headerClass = updateHeader(y)
</script>

<svelte:window bind:innerWidth="{windowWidth}" bind:scrollY="{y}" />

<header class="smooth-shadow {headerClass}">
    <div class="top">
        <div class="container">
            <div class="grid justify-space-between align-center">
                <div class="col">
                    <ul class="contact">
                        <!-- als Menü erstellen -->
                        <li>
                            <img src="/assets/icons/phone.svg" class="icon" alt="phone" />
                            <a href="tel:+49362878300">+49 3628 78300</a>
                        </li>
                        <li>
                            <img src="/assets/icons/mail.svg" class="icon" alt="mail" />
                            <a href="mailto:support@sportident.com">support@sportident.com</a>
                        </li>
                        <li>
                            <img src="/assets/icons/user-guide.svg" class="icon" alt="userguide" />
                            <a href="https://docs.sportident.com/" target="_blank">User Guide</a>
                        </li>
                    </ul>
                </div>
                <div>
                    <nav class="col si-logos">
                        <!-- als Menü erstellen -->
                        <a href="https://center.sportident.com/" target="_blank">
                            <img src="/assets/img/si-center.png" class="logo-s" alt="SORTident Center" />
                        </a>
                        <a href="https://timing.sportident.com/">
                            <img src="/assets/img/si-timing.png" class="logo-s" alt="SPORTident Timing" />
                        </a>
                    </nav>
                </div>
            </div>
        </div>
    </div>
    <div class="nav">
        <!-- nur dieser Teil soll sticky sein -->
        <div class="container">
            <div class="grid justify-space-between align-center">
                <div class="col-auto">
                    <a use:spaLink href="/">
                        <img src="/assets/img/si-logo.png" alt="SPORTident Logo" />
                    </a>
                </div>
                <!-- hamburger menu -->
                <button
                    class="hamburger"
                    aria-label="Open Menu"
                    class:active="{navOpen}"
                    on:click="{() => (navOpen = !navOpen)}"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <!-- soll Mobiles Menü öffnen -->
                {#if navigationEntry?.elements?.length > 0}
                    <nav class="col main-nav" class:show="{navOpen}">
                        <!-- als Menü erstellen, + Klasse show in mobiler Darstellung -->
                        <ul>
                            {#each navigationEntry.elements as navL1, l1idx}
                                <li class="nav-item" class:has-submenu="{navL1.elements?.length > 0}">
                                    <!-- has-submenu selbsterklärend -->
                                    <!-- if $location.path begins with navL1.page set active class -->
                                    <a
                                        use:spaLink
                                        data-spa-prevent="{isMobile && navL1.elements?.length > 0}"
                                        href="{navL1.external
                                            ? navL1.externalUrl
                                            : navL1.page + (navL1.hash ? '#' + navL1.hash : '')}"
                                        target="{navL1.external ? '_blank' : '_self'}"
                                        class:external="{navL1.external}"
                                        class:active="{$location.path.startsWith(navL1.page)}"
                                        aria-expanded="{subNavOpen[l1idx] ? 'true' : 'false'}"
                                        on:click="{(e) => {
                                            if (isMobile) e.preventDefault()
                                            subNavOpen[l1idx] = !subNavOpen[l1idx]
                                        }}">{navL1.name}</a
                                    >
                                    {#if navL1.elements?.length > 0}
                                        <ul class="sub-menu" class:show="{subNavOpen[l1idx]}">
                                            <!-- + Klasse show in der mobilen Darstellung -->
                                            {#if isMobile}
                                                <!-- Overview only in mobile, because main a is trigger for submenu -->
                                                <li>
                                                    <a
                                                        use:spaLink
                                                        href="{navL1.external
                                                            ? navL1.externalUrl
                                                            : navL1.page + (navL1.hash ? '#' + navL1.hash : '')}"
                                                        target="{navL1.external ? '_blank' : '_self'}"
                                                        class:active="{$location.path === navL1.page}"
                                                        class:external="{navL1.external}">Overview</a
                                                    >
                                                </li>
                                            {/if}
                                            {#each navL1.elements as navL2}
                                                <li>
                                                    <a
                                                        use:spaLink
                                                        href="{navL2.external
                                                            ? navL2.externalUrl
                                                            : navL2.page + (navL2.hash ? '#' + navL2.hash : '')}"
                                                        target="{navL2.external ? '_blank' : '_self'}"
                                                        class:external="{navL2.external}">{navL2.name}</a
                                                    >
                                                </li>
                                            {/each}
                                        </ul>
                                    {/if}
                                </li>
                            {/each}
                        </ul>
                    </nav>
                {/if}
                <div class="col cart-button">
                    <CartButton />
                </div>
            </div>
        </div>
    </div>
</header>
